export enum CodeListStatus {
    PENDING='PENDING',
    CLEARED= 'CLEARED'
}
